import { useState, useRef, useEffect } from 'react';
import useApi from "./useApi";

function useUser () {
    const [user, setUser] = useState(null);
    const [userList, setUserList] = useState([]);
    const [buildeTokenBalance, setBuildeTokenBalance] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const usersApi = useApi('users/save');
    const usersListApi = useApi('users/list');
    const contractorListApi = useApi('users/listContractors');
    const currentUserApi = useApi('users/current');
    const currentUserTokenBalanceApi = useApi('users/buildeTokens');
    const componentLoad = useRef(true);
    const usersListLoad = useRef(true);
    const contractorsListLoad = useRef(true);
    const currentUserLoad = useRef(true);
    const currentUserTokenBalanceLoad = useRef(true);

    useEffect(() => {
        if (componentLoad.current) {
            componentLoad.current = false;
            return;
        }

        setUser(usersApi.data);
        setError(usersApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usersApi]);

    useEffect(() => {
        if (usersListLoad.current) {
            usersListLoad.current = false;
            return;
        }

        setUserList(usersListApi.data);
        setError(usersListApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usersListApi]);

    useEffect(() => {
        if (contractorsListLoad.current) {
            contractorsListLoad.current = false;
            return;
        }

        setUserList(contractorListApi.data);
        setError(contractorListApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contractorListApi]);

    useEffect(() => {
        if (currentUserLoad.current) {
            currentUserLoad.current = false;
            return;
        }

        setUser(currentUserApi.data);
        setError(currentUserApi.error);
        setLoading(currentUserApi.loading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUserApi]);
    

    useEffect(() => {
        if (currentUserTokenBalanceLoad.current) {
            currentUserTokenBalanceLoad.current = false;
            return;
        }
    
        setLoading(currentUserTokenBalanceApi.loading);
        setBuildeTokenBalance(currentUserTokenBalanceApi.data);
        setError(currentUserTokenBalanceApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUserTokenBalanceApi]);

    const createFromAccount = async (roles) => {
        let { responseData, response } = await usersApi.jsonPost(roles || null, {}, null, true);

        if (response && !response.ok) {
            return Promise.reject(response);
        }

        if (responseData) {
            responseData.userIsNew = response.status === 201;
        }
        
        return responseData;
    };

    // eslint-disable-next-line no-unused-vars
    const createUser = async (account, token) => {
        return await usersApi.jsonPost({
            ExternalID: account.idTokenClaims.oid,
            UserName: account.username,
            Email: account.idTokenClaims.emails[0],
            FirstName: account.idTokenClaims.given_name,
            LastName: account.idTokenClaims.family_name,
            IsActive: true
        },
        {},
        token
        );
    }

    const getList = async () => {
        usersListApi.get();
    }

    const getContractorList = async () => {
        let { error } = await contractorListApi.getWithResponse();

        if (error?.response?.status === 400) {
            return error.detail;
        }
    }

    const getCurrentUser = async () => {
        currentUserApi.get();
    }

    const getBuildeTokens = async () => {
        currentUserTokenBalanceApi.get();
    };

    const updateCurrentUser = async (data) => {
        currentUserApi.jsonPost(data);
    }

    return {
        user,
        userList,
        buildeTokenBalance,
        error,
        loading,
        getList,
        getContractorList,
        getCurrentUser,
        getBuildeTokens,
        updateCurrentUser,
        createFromAccount
    };
}

export default useUser;